module.exports = __webpack_public_path__ + "quicksilver/static/media/diners-club-logo.61d6a3da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/card/card-icons/diners-club-logo.svg
// module id = 620
// module chunks = 0